var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('apexchart',{attrs:{"width":"100%","height":"300","type":"area","options":_vm.chartOptions,"series":[
      {
        name: 'Pago',
        data: _vm.formattedData,
      },
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }